"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _fp = require("lodash/fp");
var _50 = /*#__PURE__*/ _interop_require_default(require("./50"));
var _100 = /*#__PURE__*/ _interop_require_default(require("./100"));
var _200 = /*#__PURE__*/ _interop_require_default(require("./200"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var createRewards = function(id) {
    return (0, _fp.map)(function(reward) {
        return (0, _fp.defaults)(reward, {
            id: "".concat(reward.id, "-").concat(id)
        });
    }, [
        _50.default,
        _100.default,
        _200.default
    ]);
};
var _default = {
    createRewards: createRewards
};
